import type { SVGProps } from "react";
export interface WifiExclamationIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WifiExclamationIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WifiExclamationIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M7.397 14.2a1.124 1.124 0 0 1 1.485 1.69q-.18.157-.349.337a1.126 1.126 0 0 1-1.637-1.544q.241-.255.5-.484Zm7.62.102a1.125 1.125 0 0 1 1.497-.174l.09.071.254.235q.126.12.246.249a1.124 1.124 0 0 1-1.636 1.544 5 5 0 0 0-.173-.175l-.176-.162-.083-.08a1.126 1.126 0 0 1-.02-1.508ZM7.64 9.092a1.125 1.125 0 0 1 .828 2.09l-.375.183a9 9 0 0 0-2.417 1.831l-.083.08a1.125 1.125 0 0 1-1.554-1.624l.394-.398a11.1 11.1 0 0 1 3.1-2.119zm7.337.599c.242-.53.843-.781 1.383-.598l.107.042.475.23a11.2 11.2 0 0 1 2.626 1.889l.394.398.075.088a1.126 1.126 0 0 1-1.629 1.535l-.084-.079-.317-.322a9 9 0 0 0-2.1-1.51l-.374-.182-.103-.053a1.126 1.126 0 0 1-.453-1.438M7.665 4.536a1.125 1.125 0 0 1 .67 2.147c-2.01.627-3.915 1.785-5.516 3.482a1.126 1.126 0 0 1-1.638-1.544c1.865-1.978 4.103-3.343 6.484-4.085m7.261.738c.174-.556.74-.881 1.298-.767l.111.029.444.146c2.215.77 4.29 2.085 6.04 3.94a1.126 1.126 0 0 1-1.637 1.543c-1.5-1.591-3.268-2.707-5.141-3.357l-.375-.125-.109-.04a1.126 1.126 0 0 1-.631-1.369m-2.709 11.612a2.125 2.125 0 1 1-2.332 2.33L9.875 19l.01-.217a2.127 2.127 0 0 1 2.116-1.909zm-1.341-2.885V4a1.125 1.125 0 0 1 2.25 0v10a1.126 1.126 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
